<form [formGroup]="formServicios" class="service-form">

    <!-- ================================================================
         ENCABEZADO
         ================================================================ -->

    <div class="service-form-header">

        <div class="service-header-icon">
            <i class="fa-solid fa-plug"></i>
        </div>

        <div class="service-header-content">

            <span class="service-eyebrow">
                CONFIGURACIÓN
            </span>

            <h4>
                Información del servicio
            </h4>

            <p>
                Configura los datos generales y las credenciales de conexión
                del servicio externo.
            </p>

        </div>

    </div>


    <!-- ================================================================
         SECCIÓN 1 - INFORMACIÓN GENERAL
         ================================================================ -->

    <div class="form-section">

        <div class="form-section-header">

            <div class="form-section-icon">
                <i class="fa-solid fa-server"></i>
            </div>

            <div>
                <h5>Información general</h5>
                <p>Identificación y direcciones del servicio.</p>
            </div>

        </div>


        <div class="row g-3">

            <!-- ========================================================
                 NOMBRE DEL SISTEMA
                 ======================================================== -->

            <div class="col-lg-6 col-md-6 col-12">

                <div class="field-group">

                    <label class="form-label">
                        Nombre del sistema
                        <span class="required">*</span>
                    </label>

                    <div class="input-modern">

                        <span class="input-modern-icon">
                            <i class="fa-solid fa-display"></i>
                        </span>

                        <input
                            type="text"
                            class="form-control"
                            placeholder="Ej: Sistema Jobsite"
                            formControlName="nombre">

                    </div>

                    <span
                        class="field-error"
                        *ngIf="
                            formServicios.get('nombre')?.touched &&
                            formServicios.get('nombre')?.errors?.['required']
                        ">

                        <i class="fa-solid fa-circle-exclamation"></i>

                        El nombre del sistema es requerido

                    </span>

                </div>

            </div>


            <!-- ========================================================
                 NOMBRE CORTO
                 ======================================================== -->

            <div class="col-lg-6 col-md-6 col-12">

                <div class="field-group">

                    <label class="form-label">
                        Nombre corto
                        <span class="required">*</span>
                    </label>

                    <div class="input-modern input-readonly">

                        <span class="input-modern-icon">
                            <i class="fa-solid fa-tag"></i>
                        </span>

                        <input
                            type="text"
                            class="form-control"
                            placeholder="Ej: Jobsite-externo"
                            formControlName="nombre_corto"
                            [readOnly]="true">

                        <span class="input-status-icon">
                            <i class="fa-solid fa-lock"></i>
                        </span>

                    </div>

                    <span class="field-help">
                        Este identificador no puede modificarse.
                    </span>

                    <span
                        class="field-error"
                        *ngIf="
                            formServicios.get('nombre_corto')?.touched &&
                            formServicios.get('nombre_corto')?.errors?.['required']
                        ">

                        <i class="fa-solid fa-circle-exclamation"></i>

                        El nombre corto es requerido

                    </span>

                </div>

            </div>


            <!-- ========================================================
                 URL BACKEND
                 ======================================================== -->

            <div class="col-lg-6 col-md-6 col-12">

                <div class="field-group">

                    <label class="form-label">
                        URL backend
                        <span class="required">*</span>
                    </label>

                    <div class="input-modern">

                        <span class="input-modern-icon">
                            <i class="fa-solid fa-link"></i>
                        </span>

                        <input
                            type="text"
                            class="form-control"
                            placeholder="https://ejemplo-backend/api/authenticate"
                            formControlName="auth_url">

                    </div>

                    <span
                        class="field-error"
                        *ngIf="
                            formServicios.get('auth_url')?.touched &&
                            formServicios.get('auth_url')?.errors?.['required']
                        ">

                        <i class="fa-solid fa-circle-exclamation"></i>

                        La URL del backend es requerida.

                    </span>

                </div>

            </div>


            <!-- ========================================================
                 BASE URL
                 ======================================================== -->

            <div class="col-lg-6 col-md-6 col-12">

                <div class="field-group">

                    <label class="form-label">
                        Base URL
                        <span class="required">*</span>
                    </label>

                    <div class="input-modern">

                        <span class="input-modern-icon">
                            <i class="fa-solid fa-globe"></i>
                        </span>

                        <input
                            type="text"
                            class="form-control"
                            placeholder="https://ejemplo-backend-dev.bcr.gob.sv/api"
                            formControlName="base_url">

                    </div>

                    <span
                        class="field-error"
                        *ngIf="
                            formServicios.get('base_url')?.touched &&
                            formServicios.get('base_url')?.errors?.['required']
                        ">

                        <i class="fa-solid fa-circle-exclamation"></i>

                        La URL base es requerida.

                    </span>

                </div>

            </div>

        </div>

    </div>


    <!-- ================================================================
         SECCIÓN 2 - CREDENCIALES
         ================================================================ -->

    <div class="form-section credentials-section">

        <div class="form-section-header">

            <div class="form-section-icon credentials">
                <i class="fa-solid fa-key"></i>
            </div>

            <div>
                <h5>Credenciales</h5>
                <p>Información utilizada para autenticar el servicio.</p>
            </div>

        </div>


        <div class="row g-3">

            <!-- ========================================================
                 USERNAME
                 ======================================================== -->

            <div class="col-lg-6 col-md-6 col-12">

                <div class="field-group">

                    <label class="form-label">
                        Username
                        <span class="required">*</span>
                    </label>

                    <div class="input-modern">

                        <span class="input-modern-icon">
                            <i class="fa-regular fa-user"></i>
                        </span>

                        <input
                            type="text"
                            class="form-control"
                            placeholder="Ej: username"
                            formControlName="auth_username">

                    </div>

                    <span
                        class="field-error"
                        *ngIf="
                            formServicios.get('auth_username')?.touched &&
                            formServicios.get('auth_username')?.errors?.['required']
                        ">

                        <i class="fa-solid fa-circle-exclamation"></i>

                        El usuario es requerido

                    </span>

                </div>

            </div>


            <!-- ========================================================
                 PASSWORD
                 ======================================================== -->

            <div class="col-lg-6 col-md-6 col-12">

                <div class="field-group">

                    <label class="form-label">
                        Password
                        <span class="required">*</span>
                    </label>

                    <div
                        class="input-modern"
                        [class.input-readonly]="firmaGuardada">

                        <span class="input-modern-icon">
                            <i class="fa-solid fa-lock"></i>
                        </span>

                        <input
                            type="password"
                            class="form-control"
                            placeholder="**********"
                            formControlName="auth_password"
                            [readOnly]="firmaGuardada">

                    </div>

                    <span
                        class="field-error"
                        *ngIf="
                            formServicios.get('auth_password')?.touched &&
                            formServicios.get('auth_password')?.errors?.['required']
                        ">

                        <i class="fa-solid fa-circle-exclamation"></i>

                        El password es requerido

                    </span>

                </div>

            </div>

        </div>


        <!-- ============================================================
             AUTOCOMPLETAR CREDENCIALES
             ============================================================ -->

        <div
            class="credential-option"
            *ngIf="ocultarFirmaGuardada">

            <div class="credential-option-content">

                <div class="credential-option-icon">
                    <i class="fa-solid fa-wand-magic-sparkles"></i>
                </div>

                <div class="credential-option-text">

                    <strong>
                        Autocompletar credenciales
                    </strong>

                    <span>
                        Utiliza las credenciales almacenadas previamente
                        para este servicio.
                    </span>

                </div>

            </div>


            <label class="modern-switch mb-0">

                <input
                    type="checkbox"
                    [(ngModel)]="firmaGuardada"
                    [ngModelOptions]="{ standalone: true }"
                    (ngModelChange)="onChangeFirmaGuardada()">

                <span class="slider"></span>

            </label>

        </div>

    </div>


    <!-- ================================================================
         ACCIONES
         ================================================================ -->

    <div class="service-form-actions">

        <div class="action-info">

            <i class="fa-solid fa-circle-info"></i>

            <span>
                Verifica la información antes de guardar los cambios.
            </span>

        </div>


        <button
            type="button"
            class="save-service-button"
            (click)="editarServicio()"
            [disabled]="formServiciosIsSubmited || formServicios.invalid">

            <span
                class="spinner-border spinner-border-sm"
                *ngIf="formServiciosIsSubmited">
            </span>

            <i
                class="fa-solid fa-floppy-disk"
                *ngIf="!formServiciosIsSubmited">
            </i>

            <span>
                Guardar cambios
            </span>

        </button>

    </div>

</form>